import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { developerToolsModuleQuery } from 'system/structure-modules';

export default function DeveloperToolsLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/developer-tools/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'developer-tools',
        instanceKey: 'one',
        moduleQuery: developerToolsModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
